import React, {useState} from "react";
import cn from "classnames";
import * as styles from "./FooterMenu.module.scss";
import MenuItem from "../../MenuItem/MenuItem";

export function FooterMenu({headerInsert}) {
  const columns = [
    {
      headline: "Solutions",
      items: [
        { href: "/product-management", title: "Product", text: "Product" },
        { href: "/digital-agency", title: "Digital agency", text: "Digital agency" },
        { href: "/software-development", title: "Software development", text: "Software development" },
        { href: "/startups", title: "Startup", text: "Startup" },
      ],
    },
    {
      headline: "Platform",
      items: [
        { href: "/pricing", title: "Pricing", text: "Pricing" },
        { href: "/features", title: "Features", text: "Features" },
        { href: "/templates", title: "Templates", text: "Template library" },
        { href: "/templates#integrations", title: "Integrations", text: "Integrations" },
        { href: "/ai", title: "Fibery AI", text: "Fibery AI" },
        !headerInsert && { href: "/download", title: "/download", text: "Download app" },
        !headerInsert && { href: "/features/browser-extension", title: "", text: "Browser extension" },
      ]
    },
    {
      headline: "Support",
      items: [
        { href: "/getting-started", title: "Getting started", text: "Getting started" },
        { href: "/expert-help", title: "Expert help", text: "Expert help" },
        { href: "https://fibery.io/webinars/", title: "Webinars & Tutorials", text: "Webinars & tutorials" },
        { href: "https://help.fibery.io/", target: "_blank", title: "Fibery User Guide", text: "User guide" },
        { href: "https://status.fibery.io/", target: "_blank", title: "Fibery Status", text: "Status" },
        { href: "https://community.fibery.io", target: "_blank", title: "Fibery Community", text: "Community" },
      ],
    },
    {
      headline: "Resources",
      items: [
        { href: "https://fibery.io/blog/", title: "Blog", text: "Blog" },
        { href: "/customer-stories", title: "Customer stories", text: "Customer stories" },
        { href: "/partners", title: "Partners program", text: "Partners program" },
        { href: "/startup-program", title: "Startup program", text: "Startup program" },
        { href: "/fibery-vs-x", title: "Fibery vs. X", text: "Fibery vs. X" },
        { href: "https://api.fibery.io/", target: "_blank", title: "Fibery API", text: "API" },
        { href: "https://the.fibery.io/@public/Changelog/Release-Notes-7884", target: "_blank", title: "Changelog", text: "Changelog" },
        { href: "/security", title: "Security & Privacy", text: "Security & privacy" },
        {href: "", title: "", text: " "},
      ],
    },
    {
      headline: "Company",
      items: [
        { href: "/about-us", title: "About us", text: "About us" },
        { href: "/open-startup", title: "Open startup", text: "Open startup" },
        { href: "https://fibery.io/blog/startup-diary/", title: "Startup diary", text: "Startup diary" },
        { href: "https://fibery.io/blog/we-are-hiring/", title: "Careers", text: "Careers" },
        {
          href: "/anxiety",
          title: "Anxiety",
          text: "Anxiety?",
          withBadge: "fun",
        },
      ],
    },
  ];

  const [activeColumns, setActiveColumns] = useState([true, false, false, false]);

  const toggleActive = (index) => {
    setActiveColumns((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <div className={cn(styles.root, headerInsert ? styles.headerInsert : null)}>
      {columns.map((column, index) => (
        <div key={index} className={styles.column}>
          <div
            className={cn(styles.mobMenuHead, activeColumns[index] ? styles.expand : null)}
            onClick={() => toggleActive(index)}
          >
            <MenuItem isHeadline={true}>{column.headline}</MenuItem>
          </div>
          <div className={cn(styles.mobMenuBody, activeColumns[index] ? styles.active : null)}>
            {column.items.map((item, itemIndex) => (
              <MenuItem
                key={itemIndex}
                href={item.href}
                title={item.title}
                withBadge={item.withBadge}
                target={item.target}
              >
                {item.text}
              </MenuItem>
            ))}
          </div>
        </div>
      ))}
    </div>);
}
